import React, { useState, useEffect } from 'react';
import Header from '../../components/ui/Header';
import PropertyCard from './components/PropertyCard';
import StatsCard from './components/StatsCard';
import InquiryCard from './components/InquiryCard';
import PerformanceChart from './components/PerformanceChart';
import QuickActions from './components/QuickActions';
import RecentActivity from './components/RecentActivity';
import MarketInsights from './components/MarketInsights';
import Button from '../../components/ui/Button';
import Select from '../../components/ui/Select';
import Input from '../../components/ui/Input';
import Icon from '../../components/AppIcon';

const OwnerPortal = () => {
  const [activeTab, setActiveTab] = useState('overview');
  const [selectedProperty, setSelectedProperty] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [newProperty, setNewProperty] = useState({
    title: '',
    location: '',
    price: '',
    originalPrice: '',
    type: 'rent',
    bedrooms: 1,
    bathrooms: 1,
    area: '',
    furnishing: 'Unfurnished',
    status: 'available',
    isNew: false,
    ownerVerified: true,
    amenities: '',
    images: 'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=800&h=600&fit=crop'
  });
  const [formError, setFormError] = useState('');

  // Mock data for owner properties
  const initialOwnerProperties = [
    {
      id: 1,
      title: "Luxury 3BHK Apartment in Bandra West",
      location: "Bandra West, Mumbai",
      price: 85000,
      type: "rent",
      bedrooms: 3,
      area: 1200,
      status: "active",
      views: 245,
      inquiries: 12,
      favorites: 8,
      newInquiries: 3,
      images: ["https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=400"]
    },
    {
      id: 2,
      title: "Modern 2BHK with Sea View",
      location: "Worli, Mumbai",
      price: 1250000,
      type: "sale",
      bedrooms: 2,
      area: 950,
      status: "pending",
      views: 189,
      inquiries: 8,
      favorites: 15,
      newInquiries: 1,
      images: ["https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=400"]
    },
    {
      id: 3,
      title: "Spacious 4BHK Villa in Juhu",
      location: "Juhu, Mumbai",
      price: 150000,
      type: "rent",
      bedrooms: 4,
      area: 2200,
      status: "active",
      views: 312,
      inquiries: 18,
      favorites: 22,
      newInquiries: 5,
      images: ["https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=400"]
    }
  ];

  const [ownerProperties, setOwnerProperties] = useState(initialOwnerProperties);

  // Mock data for inquiries
  const inquiries = [
    {
      id: 1,
      userName: "Priya Sharma",
      userEmail: "priya.sharma@email.com",
      userPhone: "+91 98765 43210",
      userLocation: "Andheri East",
      userAvatar: "https://randomuser.me/api/portraits/women/32.jpg",
      isVerified: true,
      propertyTitle: "Luxury 3BHK Apartment in Bandra West",
      message: "Hi, I'm interested in this property. Can we schedule a viewing this weekend? I'm looking for immediate possession.",
      status: "new",
      leadScore: 8,
      createdAt: new Date(Date.now() - 2 * 60 * 60 * 1000)
    },
    {
      id: 2,
      userName: "Rajesh Kumar",
      userEmail: "rajesh.k@email.com",
      userPhone: "+91 87654 32109",
      userLocation: "Powai",
      userAvatar: "https://randomuser.me/api/portraits/men/45.jpg",
      isVerified: false,
      propertyTitle: "Modern 2BHK with Sea View",
      message: "I would like to know more about the amenities and parking availability. Also, is the price negotiable?",
      status: "responded",
      leadScore: 6,
      createdAt: new Date(Date.now() - 5 * 60 * 60 * 1000)
    },
    {
      id: 3,
      userName: "Sneha Patel",
      userEmail: "sneha.patel@email.com",
      userPhone: "+91 76543 21098",
      userLocation: "Bandra West",
      userAvatar: "https://randomuser.me/api/portraits/women/28.jpg",
      isVerified: true,
      propertyTitle: "Spacious 4BHK Villa in Juhu",
      message: "This looks perfect for my family. Can you share more photos of the interior and garden area?",
      status: "viewed",
      leadScore: 9,
      createdAt: new Date(Date.now() - 8 * 60 * 60 * 1000)
    }
  ];

  // Mock data for performance charts
  const viewsData = [
    { name: 'Jan', value: 120 },
    { name: 'Feb', value: 190 },
    { name: 'Mar', value: 300 },
    { name: 'Apr', value: 250 },
    { name: 'May', value: 400 },
    { name: 'Jun', value: 350 },
    { name: 'Jul', value: 450 }
  ];

  const inquiriesData = [
    { name: 'Jan', value: 8 },
    { name: 'Feb', value: 12 },
    { name: 'Mar', value: 18 },
    { name: 'Apr', value: 15 },
    { name: 'May', value: 22 },
    { name: 'Jun', value: 19 },
    { name: 'Jul', value: 28 }
  ];

  // Mock data for recent activities
  const recentActivities = [
    {
      type: 'inquiry',
      title: 'New inquiry received',
      description: 'Priya Sharma inquired about your Bandra West property',
      propertyTitle: 'Luxury 3BHK Apartment in Bandra West',
      timestamp: new Date(Date.now() - 30 * 60 * 1000)
    },
    {
      type: 'view',
      title: 'Property viewed',
      description: 'Your Juhu villa was viewed 15 times today',
      propertyTitle: 'Spacious 4BHK Villa in Juhu',
      timestamp: new Date(Date.now() - 2 * 60 * 60 * 1000)
    },
    {
      type: 'favorite',
      title: 'Property saved',
      description: '3 users saved your Worli apartment to their favorites',
      propertyTitle: 'Modern 2BHK with Sea View',
      timestamp: new Date(Date.now() - 4 * 60 * 60 * 1000)
    },
    {
      type: 'verification',
      title: 'Profile verified',
      description: 'Your owner profile has been successfully verified',
      timestamp: new Date(Date.now() - 24 * 60 * 60 * 1000)
    }
  ];

  // Mock data for market insights
  const marketInsights = [
    {
      type: 'price',
      title: 'Pricing Opportunity',
      description: 'Your Bandra West property is priced 8% below market average. Consider increasing rent by ₹5,000-7,000.',
      impact: 'positive',
      recommendation: 'Increase rent to ₹90,000-92,000 to match market rates while maintaining competitiveness.',
      metrics: [
        { label: 'Market Avg', value: 92000, type: 'currency' },
        { label: 'Your Price', value: 85000, type: 'currency' },
        { label: 'Potential Increase', value: '8.2%', type: 'text' }
      ]
    },
    {
      type: 'demand',
      title: 'High Demand Area',
      description: 'Juhu area is experiencing 25% higher demand this month compared to last month.',
      impact: 'positive',
      recommendation: 'This is an excellent time to list additional properties in Juhu or consider premium pricing.',
      metrics: [
        { label: 'Demand Increase', value: '25%', type: 'text' },
        { label: 'Avg Days to Rent', value: '12 days', type: 'text' }
      ]
    },
    {
      type: 'competition',
      title: 'Competition Alert',
      description: '5 similar properties were listed in Worli this week, increasing competition for your 2BHK.',
      impact: 'neutral',
      recommendation: 'Consider highlighting unique features or offering flexible terms to stand out.',
      metrics: [
        { label: 'New Listings', value: '5', type: 'text' },
        { label: 'Price Range', value: '₹1.1M-1.4M', type: 'text' }
      ]
    }
  ];

  // Property filter options
  const propertyOptions = [
    { value: 'all', label: 'All Properties' },
    ...ownerProperties.map(property => ({
      value: property.id.toString(),
      label: property.title
    }))
  ];

  // Tab configuration
  const tabs = [
    { id: 'overview', label: 'Overview', icon: 'LayoutDashboard' },
    { id: 'properties', label: 'Properties', icon: 'Home' },
    { id: 'inquiries', label: 'Inquiries', icon: 'MessageSquare' },
    { id: 'analytics', label: 'Analytics', icon: 'BarChart3' },
    { id: 'insights', label: 'Market Insights', icon: 'TrendingUp' }
  ];

  // Filter properties based on search and selection
  const filteredProperties = ownerProperties.filter(property => {
    const matchesSearch = property.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
                         property.location.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesSelection = selectedProperty === 'all' || property.id.toString() === selectedProperty;
    return matchesSearch && matchesSelection;
  });

  // Calculate stats
  const totalProperties = ownerProperties.length;
  const activeProperties = ownerProperties.filter(p => p.status === 'active').length;
  const totalInquiries = ownerProperties.reduce((sum, p) => sum + p.inquiries, 0);
  const newInquiries = ownerProperties.reduce((sum, p) => sum + p.newInquiries, 0);
  const totalViews = ownerProperties.reduce((sum, p) => sum + p.views, 0);
  const totalFavorites = ownerProperties.reduce((sum, p) => sum + p.favorites, 0);

  // Event handlers
  const handleEditProperty = (propertyId) => {
    console.log('Edit property:', propertyId);
  };

  const handleViewAnalytics = (propertyId) => {
    setActiveTab('analytics');
    setSelectedProperty(propertyId?.toString() || 'all');
  };

  const handleManageInquiries = (propertyId) => {
    setActiveTab('inquiries');
    setSelectedProperty(propertyId?.toString() || 'all');
  };

  const handleRespondToInquiry = (inquiryId) => {
    console.log('Respond to inquiry:', inquiryId);
  };

  const handleViewProfile = (inquiryId) => {
    console.log('View profile:', inquiryId);
  };

  const handleAddProperty = () => {
    setFormError('');
    setNewProperty({
      title: '',
      location: '',
      price: '',
      originalPrice: '',
      type: 'rent',
      bedrooms: 1,
      bathrooms: 1,
      area: '',
      furnishing: 'Unfurnished',
      status: 'available',
      isNew: false,
      ownerVerified: true,
      amenities: '',
      images: 'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=800&h=600&fit=crop'
    });
    setIsAddModalOpen(true);
  };

  const handleSaveNewProperty = () => {
    if (!newProperty.title || !newProperty.location || !newProperty.price) {
      setFormError('Title, location and price are required');
      return;
    }
    const nextId = (ownerProperties.reduce((max, p) => Math.max(max, p.id), 0) || 0) + 1;
    const priceNumber = parseInt(newProperty.price, 10) || 0;
    const areaNumber = parseInt(newProperty.area, 10) || 0;
    const created = {
      id: nextId,
      title: newProperty.title,
      location: newProperty.location,
      price: priceNumber,
      originalPrice: newProperty.originalPrice ? parseInt(newProperty.originalPrice, 10) : undefined,
      type: newProperty.type,
      bedrooms: parseInt(newProperty.bedrooms, 10) || 1,
      bathrooms: parseInt(newProperty.bathrooms, 10) || 1,
      area: areaNumber,
      furnishing: newProperty.furnishing,
      status: newProperty.status,
      isNew: !!newProperty.isNew,
      ownerVerified: !!newProperty.ownerVerified,
      views: 0,
      inquiries: 0,
      favorites: 0,
      newInquiries: 0,
      images: (newProperty.images || '').split(',').map(s => s.trim()).filter(Boolean),
      amenities: (newProperty.amenities || '').split(',').map(s => s.trim()).filter(Boolean),
      owner: {
        name: 'Owner',
        type: 'Owner',
        avatar: 'https://randomuser.me/api/portraits/men/32.jpg'
      },
      postedDate: 'just now',
      lastUpdated: 'just now'
    };
    setOwnerProperties(prev => [created, ...prev]);
    setIsAddModalOpen(false);
  };

  const handleUpdateProfile = () => {
    console.log('Update profile');
  };

  return (
    <div className="min-h-screen bg-canvas">
      <Header />
      
      <div className="pt-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          {/* Page Header */}
          <div className="mb-8">
            <div className="flex items-center justify-between">
              <div>
                <h1 className="text-3xl font-bold text-text-primary">Owner Portal</h1>
                <p className="text-text-secondary mt-2">
                  Manage your properties, track performance, and connect with potential tenants
                </p>
              </div>
              <div className="flex items-center space-x-3">
                <Button
                  variant="outline"
                  iconName="Bell"
                  iconPosition="left"
                >
                  Notifications ({newInquiries})
                </Button>
                <Button
                  variant="default"
                  iconName="Plus"
                  iconPosition="left"
                  onClick={handleAddProperty}
                >
                  Add Property
                </Button>
              </div>
            </div>
          </div>

          {/* Navigation Tabs */}
          <div className="mb-8">
            <div className="border-b border-border">
              <nav className="flex space-x-8">
                {tabs.map((tab) => (
                  <button
                    key={tab.id}
                    onClick={() => setActiveTab(tab.id)}
                    className={`flex items-center space-x-2 py-4 px-1 border-b-2 font-medium text-sm transition-colors ${
                      activeTab === tab.id
                        ? 'border-primary text-primary' :'border-transparent text-text-secondary hover:text-text-primary hover:border-gray-300'
                    }`}
                  >
                    <Icon name={tab.icon} size={16} />
                    <span>{tab.label}</span>
                  </button>
                ))}
              </nav>
            </div>
          </div>

          {/* Overview Tab */}
          {activeTab === 'overview' && (
            <div className="space-y-8">
              {/* Stats Cards */}
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                <StatsCard
                  title="Total Properties"
                  value={totalProperties}
                  icon="Home"
                  color="primary"
                />
                <StatsCard
                  title="Active Listings"
                  value={activeProperties}
                  change="+2 this month"
                  changeType="positive"
                  icon="CheckCircle"
                  color="success"
                />
                <StatsCard
                  title="Total Inquiries"
                  value={totalInquiries}
                  change="+15% this week"
                  changeType="positive"
                  icon="MessageSquare"
                  color="warning"
                />
                <StatsCard
                  title="Total Views"
                  value={totalViews}
                  change="+8% this month"
                  changeType="positive"
                  icon="Eye"
                  color="secondary"
                />
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                {/* Quick Actions */}
                <QuickActions
                  onAddProperty={handleAddProperty}
                  onViewAnalytics={() => handleViewAnalytics()}
                  onManageInquiries={() => handleManageInquiries()}
                  onUpdateProfile={handleUpdateProfile}
                />

                {/* Recent Activity */}
                <RecentActivity activities={recentActivities} />
              </div>

              {/* Performance Charts */}
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                <PerformanceChart
                  data={viewsData}
                  type="line"
                  title="Property Views Trend"
                  color="#2563EB"
                />
                <PerformanceChart
                  data={inquiriesData}
                  type="bar"
                  title="Monthly Inquiries"
                  color="#059669"
                />
              </div>
            </div>
          )}

          {/* Properties Tab */}
          {activeTab === 'properties' && (
            <div className="space-y-6">
              {/* Filters */}
              <div className="flex flex-col sm:flex-row gap-4">
                <div className="flex-1">
                  <Input
                    type="search"
                    placeholder="Search properties..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                </div>
                <div className="w-full sm:w-64">
                  <Select
                    options={propertyOptions}
                    value={selectedProperty}
                    onChange={setSelectedProperty}
                    placeholder="Filter by property"
                  />
                </div>
              </div>

              {/* Properties Grid */}
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {filteredProperties.map((property) => (
                  <PropertyCard
                    key={property.id}
                    property={property}
                    onEdit={handleEditProperty}
                    onViewAnalytics={handleViewAnalytics}
                    onManageInquiries={handleManageInquiries}
                  />
                ))}
              </div>

              {filteredProperties.length === 0 && (
                <div className="text-center py-12">
                  <Icon name="Home" size={48} className="mx-auto text-text-secondary mb-4" />
                  <h3 className="text-lg font-medium text-text-primary mb-2">No properties found</h3>
                  <p className="text-text-secondary mb-4">
                    {searchQuery ? 'Try adjusting your search terms' : 'Start by adding your first property'}
                  </p>
                  <Button
                    variant="default"
                    iconName="Plus"
                    iconPosition="left"
                    onClick={handleAddProperty}
                  >
                    Add Property
                  </Button>
                </div>
              )}
            </div>
          )}

          {/* Inquiries Tab */}
          {activeTab === 'inquiries' && (
            <div className="space-y-6">
              {/* Inquiry Stats */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <StatsCard
                  title="New Inquiries"
                  value={newInquiries}
                  icon="MessageSquare"
                  color="primary"
                />
                <StatsCard
                  title="Response Rate"
                  value="92%"
                  change="+5% this week"
                  changeType="positive"
                  icon="CheckCircle"
                  color="success"
                />
                <StatsCard
                  title="Avg Response Time"
                  value="2.5 hrs"
                  change="-30 min"
                  changeType="positive"
                  icon="Clock"
                  color="warning"
                />
              </div>

              {/* Inquiries List */}
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                {inquiries.map((inquiry) => (
                  <InquiryCard
                    key={inquiry.id}
                    inquiry={inquiry}
                    onRespond={handleRespondToInquiry}
                    onViewProfile={handleViewProfile}
                  />
                ))}
              </div>
            </div>
          )}

          {/* Analytics Tab */}
          {activeTab === 'analytics' && (
            <div className="space-y-8">
              {/* Analytics Header */}
              <div className="flex items-center justify-between">
                <h2 className="text-xl font-semibold text-text-primary">Performance Analytics</h2>
                <Select
                  options={propertyOptions}
                  value={selectedProperty}
                  onChange={setSelectedProperty}
                  placeholder="Select property"
                />
              </div>

              {/* Performance Metrics */}
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                <StatsCard
                  title="Total Views"
                  value={totalViews}
                  change="+12% vs last month"
                  changeType="positive"
                  icon="Eye"
                  color="primary"
                />
                <StatsCard
                  title="Inquiries"
                  value={totalInquiries}
                  change="+8% vs last month"
                  changeType="positive"
                  icon="MessageSquare"
                  color="success"
                />
                <StatsCard
                  title="Favorites"
                  value={totalFavorites}
                  change="+15% vs last month"
                  changeType="positive"
                  icon="Heart"
                  color="error"
                />
                <StatsCard
                  title="Conversion Rate"
                  value="4.8%"
                  change="+0.5% vs last month"
                  changeType="positive"
                  icon="Target"
                  color="warning"
                />
              </div>

              {/* Charts */}
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                <PerformanceChart
                  data={viewsData}
                  type="line"
                  title="Views Over Time"
                  color="#2563EB"
                />
                <PerformanceChart
                  data={inquiriesData}
                  type="bar"
                  title="Inquiries by Month"
                  color="#059669"
                />
              </div>
            </div>
          )}

          {/* Market Insights Tab */}
          {activeTab === 'insights' && (
            <div className="space-y-8">
              <div className="flex items-center justify-between">
                <h2 className="text-xl font-semibold text-text-primary">Market Insights</h2>
                <div className="text-sm text-text-secondary">
                  Last updated: {new Date().toLocaleDateString('en-IN')}
                </div>
              </div>

              <MarketInsights insights={marketInsights} />
            </div>
          )}
        </div>
      </div>

    {/* Add Property Modal */}
    {isAddModalOpen && (
      <div className="fixed inset-0 z-[60] flex items-center justify-center">
        <div className="absolute inset-0 bg-black/40" onClick={() => setIsAddModalOpen(false)}></div>
        <div className="relative bg-surface border border-border rounded-lg w-full max-w-lg p-6 shadow-property-card">
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-xl font-semibold text-text-primary">Add New Property</h2>
            <button className="text-text-secondary hover:text-text-primary" onClick={() => setIsAddModalOpen(false)}>
              <Icon name="X" size={20} />
            </button>
          </div>
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-text-secondary mb-1">Title</label>
              <Input value={newProperty.title} onChange={(e) => setNewProperty({ ...newProperty, title: e.target.value })} placeholder="e.g., Cozy 2BHK in Bandra" />
            </div>
            <div>
              <label className="block text-sm font-medium text-text-secondary mb-1">Location</label>
              <Input value={newProperty.location} onChange={(e) => setNewProperty({ ...newProperty, location: e.target.value })} placeholder="e.g., Bandra West, Mumbai" />
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-text-secondary mb-1">Price</label>
                <Input type="number" value={newProperty.price} onChange={(e) => setNewProperty({ ...newProperty, price: e.target.value })} placeholder="e.g., 90000" />
              </div>
              <div>
                <label className="block text-sm font-medium text-text-secondary mb-1">Area (sq ft)</label>
                <Input type="number" value={newProperty.area} onChange={(e) => setNewProperty({ ...newProperty, area: e.target.value })} placeholder="e.g., 1200" />
              </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-text-secondary mb-1">Type</label>
                <Select
                  options={[{ value: 'rent', label: 'Rent' }, { value: 'sale', label: 'Sale' }]}
                  value={newProperty.type}
                  onChange={(v) => setNewProperty({ ...newProperty, type: v })}
                  placeholder="Select type"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-text-secondary mb-1">Bedrooms</label>
                <Select
                  options={[1,2,3,4,5].map(n => ({ value: n, label: `${n} BHK` }))}
                  value={newProperty.bedrooms}
                  onChange={(v) => setNewProperty({ ...newProperty, bedrooms: v })}
                  placeholder="Select bedrooms"
                />
              </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-text-secondary mb-1">Bathrooms</label>
                <Select
                  options={[1,2,3,4].map(n => ({ value: n, label: `${n}` }))}
                  value={newProperty.bathrooms}
                  onChange={(v) => setNewProperty({ ...newProperty, bathrooms: v })}
                  placeholder="Select bathrooms"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-text-secondary mb-1">Furnishing</label>
                <Select
                  options={[
                    { value: 'Unfurnished', label: 'Unfurnished' },
                    { value: 'Semi Furnished', label: 'Semi Furnished' },
                    { value: 'Fully Furnished', label: 'Fully Furnished' }
                  ]}
                  value={newProperty.furnishing}
                  onChange={(v) => setNewProperty({ ...newProperty, furnishing: v })}
                  placeholder="Select furnishing"
                />
              </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-text-secondary mb-1">Status</label>
                <Select
                  options={[
                    { value: 'available', label: 'Available' },
                    { value: 'few_left', label: 'Few Left' },
                    { value: 'sold_out', label: 'Sold Out' }
                  ]}
                  value={newProperty.status}
                  onChange={(v) => setNewProperty({ ...newProperty, status: v })}
                  placeholder="Select status"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-text-secondary mb-1">Original Price (optional)</label>
                <Input type="number" value={newProperty.originalPrice} onChange={(e) => setNewProperty({ ...newProperty, originalPrice: e.target.value })} placeholder="e.g., 100000" />
              </div>
            </div>
            <div>
              <label className="block text-sm font-medium text-text-secondary mb-1">Amenities (comma separated)</label>
              <Input value={newProperty.amenities} onChange={(e) => setNewProperty({ ...newProperty, amenities: e.target.value })} placeholder="Parking, Gym, Security" />
            </div>
            <div>
              <label className="block text-sm font-medium text-text-secondary mb-1">Image URLs (comma separated)</label>
              <Input value={newProperty.images} onChange={(e) => setNewProperty({ ...newProperty, images: e.target.value })} placeholder="https://... , https://..." />
              <p className="text-xs text-text-secondary mt-1">First image will be used as the cover.</p>
            </div>
            {formError && <div className="text-sm text-red-600">{formError}</div>}
            <div className="flex items-center justify-end gap-3 pt-2">
              <Button variant="outline" onClick={() => setIsAddModalOpen(false)}>Cancel</Button>
              <Button variant="default" iconName="Save" iconPosition="left" onClick={handleSaveNewProperty}>Save Property</Button>
            </div>
          </div>
        </div>
      </div>
    )}
    </div>
  );
};

export default OwnerPortal;